<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.5 3.5H10.5V12.5H13.5V3.5Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M15.5 1.5H0.5V14.5H15.5V1.5Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>
